var _style, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 139.9 44",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#4285f4}.st1{fill:#ea4335}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5 15.7v4.7h11.3c-.3 2.6-1.2 4.6-2.6 5.9-1.6 1.6-4.2 3.4-8.7 3.4-6.9 0-12.3-5.6-12.3-12.5S10.5 4.7 17.5 4.7c3.7 0 6.5 1.5 8.5 3.4l3.3-3.3C26.5 2.1 22.7 0 17.5 0 8 0 0 7.7 0 17.2s8 17.2 17.5 17.2c5.1 0 9-1.7 12-4.8 3.1-3.1 4.1-7.5 4.1-11 0-1.1-.1-2.1-.2-2.9H17.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.6 11.8c-6.1 0-11.2 4.7-11.2 11.1 0 6.4 5 11.1 11.2 11.1s11.2-4.6 11.2-11c0-6.5-5-11.2-11.2-11.2zm0 17.9c-3.4 0-6.3-2.8-6.3-6.7 0-4 2.9-6.7 6.3-6.7s6.3 2.7 6.3 6.7c0 3.9-2.9 6.7-6.3 6.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.3 14.3h-.2c-1.1-1.3-3.2-2.5-5.9-2.5-5.6 0-10.4 4.8-10.4 11.1 0 6.2 4.8 11.1 10.4 11.1 2.7 0 4.8-1.2 5.9-2.5h.2v1.6c0 4.2-2.3 6.5-5.9 6.5-3 0-4.8-2.1-5.6-4l-4.2 1.8c1.2 2.9 4.5 6.6 9.9 6.6 5.7 0 10.6-3.4 10.6-11.6v-20h-4.6v1.9zm-5.6 15.4c-3.4 0-5.9-2.9-5.9-6.7 0-3.9 2.6-6.7 5.9-6.7 3.3 0 5.9 2.9 5.9 6.8.1 3.8-2.5 6.6-5.9 6.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 11.8c-6.1 0-11.2 4.7-11.2 11.1 0 6.4 5 11.1 11.2 11.1s11.2-4.6 11.2-11c0-6.5-5-11.2-11.2-11.2zm0 17.9c-3.4 0-6.3-2.8-6.3-6.7 0-4 2.9-6.7 6.3-6.7s6.3 2.7 6.3 6.7c0 3.9-2.9 6.7-6.3 6.7z",
    fill: "#fbbc05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.8.5h4.8v33.6h-4.8V.5z",
    fill: "#34a853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.4 29.7c-2.5 0-4.2-1.1-5.4-3.4l14.9-6.1-.5-1.3c-.9-2.5-3.8-7.1-9.5-7.1s-10.5 4.5-10.5 11.1c0 6.2 4.7 11.1 11 11.1 5.1 0 8-3.1 9.3-4.9l-3.8-2.5c-1.3 1.9-3 3.1-5.5 3.1zm-.3-13.7c2 0 3.7 1 4.2 2.4l-10 4.2c-.1-4.6 3.3-6.6 5.8-6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.eeba4596940542b63ef9a876a96b56c2.svg";
export { ForwardRef as ReactComponent };